<template>
  <!-- <List :mapState="'adminTurns'" :allDispatch="'adminTurnsAll'"></List>-->
  <b-card>
    <h3>En desarrollo</h3>
  </b-card>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/admin/turns/list.vue